import { TileAction, TileIds, TileRules, TileType } from '../../../util/tileEnums';
import {
  EMERGENCY_ROOM_VALUE,
  PRIMARY_CARE_PHYSICIAN_VALUE,
  SPECIALIST_VALUE,
  URGENT_CARE_VALUE,
} from '../../../../../Home/Tiles/ProviderTypes';
import { COPAY_COINSURANCE_DETAILS_MODAL } from '../../../../../../constants/modalIds';
import ServiceComingSoonSubtext from '../insurance_insight_subtexts/ServiceComingSoonSubtext';

const copayCoinsuranceDescriptions = [
  {
    id: TileIds.COPAY,
    description: 'Copay',
    type: TileType.COPAY_COINSURANCE,
    subtext: "Your up-front fee for care. It's usually collected at the doctor's office.",
    icon: '/images/insurance/copay.png',
    rules: [TileRules.FULL_INSURANCE_DATA, TileRules.HAS_NO_COPAY_DATA],
    action: TileAction.TRACK_CLICK,
  },
  {
    id: TileIds.COINSURANCE,
    type: TileType.COPAY_COINSURANCE,
    description: 'Coinsurance',
    subtext: 'Percent you pay after hitting your deductible. Insurance pays the rest.',
    icon: '/images/insurance/coinsurance.png',
    rules: [TileRules.FULL_INSURANCE_DATA, TileRules.HAS_NO_COPAY_DATA],
    action: TileAction.TRACK_CLICK,
  },
  {
    id: TileIds.COPAY_COINSURANCE_BY_SERVICE_UC,
    description: 'Urgent care',
    type: TileType.COPAY_COINSURANCE_BY_SERVICE,
    subtext: '',
    icon: '/images/insurance/copays/urgent_care.png',
    providerType: URGENT_CARE_VALUE,
    rules: [TileRules.FULL_INSURANCE_DATA, TileRules.HAS_URGENT_CARE_COPAY_DATA],
    action: TileAction.OPEN_MODAL,
    modalId: COPAY_COINSURANCE_DETAILS_MODAL,
    modalValue: URGENT_CARE_VALUE,
    shouldShowBookCta: false,
  },
  {
    id: TileIds.COPAY_CONINSURANCE_PCP,
    description: 'Primary care',
    type: TileType.COPAY_COINSURANCE_BY_SERVICE,
    subtext: '',
    icon: '/images/insurance/copays/primary_doctor.png',
    providerType: PRIMARY_CARE_PHYSICIAN_VALUE,
    rules: [TileRules.FULL_INSURANCE_DATA, TileRules.HAS_PCP_COPAY_DATA],
    modalId: COPAY_COINSURANCE_DETAILS_MODAL,
    modalValue: PRIMARY_CARE_PHYSICIAN_VALUE,
    shouldShowBookCta: false,
  },
  {
    id: TileIds.COPAY_CONINSURANCE_SPECIALIST,
    description: 'Specialist',
    type: TileType.COPAY_COINSURANCE_BY_SERVICE,
    subtext: '',
    icon: '/images/insurance/copays/specialist.png',
    providerType: SPECIALIST_VALUE,
    rules: [TileRules.FULL_INSURANCE_DATA, TileRules.HAS_SPECIALIST_COPAY_DATA],
    modalId: COPAY_COINSURANCE_DETAILS_MODAL,
    modalValue: SPECIALIST_VALUE,
    shouldShowBookCta: false,
  },
  {
    id: TileIds.COPAY_CONINSURANCE_ER,
    description: 'Emergency room',
    type: TileType.COPAY_COINSURANCE_BY_SERVICE,
    subtext: '',
    icon: '/images/insurance/copays/er_visit.png',
    providerType: EMERGENCY_ROOM_VALUE,
    rules: [TileRules.FULL_INSURANCE_DATA, TileRules.HAS_EMERGENCY_ROOM_COPAY_DATA],
    modalId: COPAY_COINSURANCE_DETAILS_MODAL,
    modalValue: EMERGENCY_ROOM_VALUE,
    shouldShowBookCta: false,
  },
  {
    id: TileIds.COPAY_COINSURANCE_BY_SERVICE_COMING_SOON,
    description: 'More coming soon!',
    type: TileType.COPAY_COINSURANCE_BY_SERVICE_COMING_SOON,
    subtext: ServiceComingSoonSubtext,
    icon: '/images/insurance/coming_soon.png',
    rules: [TileRules.FULL_INSURANCE_DATA, TileRules.HAS_FEWER_THAN_THREE_COPAYS],
    action: TileAction.TRACK_CLICK,
  },
];
export { copayCoinsuranceDescriptions };
